import {Injectable} from '@angular/core';
import {Inlandsadresse, StammdatenAdresse} from '@nachdigal';
import {AbstractMapper} from '../../abstract.mapper';

@Injectable()
export class InlandsadresseMapperService extends AbstractMapper<StammdatenAdresse, Inlandsadresse> {

  public mapArray(source: Array<StammdatenAdresse>): Array<Inlandsadresse> {
    return super.mapArray(source?.filter(value => value.typ === StammdatenAdresse.TypEnum.NUMBER_0));
  }

  public getMappedArrayDefaultIndex(source: Array<StammdatenAdresse>): number {
    return source.filter(value => value.typ === StammdatenAdresse.TypEnum.NUMBER_0)
      .findIndex(value => value.standard);
  }

  protected mapInternal(source: StammdatenAdresse): Inlandsadresse {

    if (source.typ !== StammdatenAdresse.TypEnum.NUMBER_0) {
      return undefined;
    }

    return {
      strasse: source.inland.strasse,
      hausnummer: source.inland.hausnummer,
      hausnummernzusatz: source.inland.hausnummernzusatz,
      adressergaenzung: source.inland.anschriftenzusatz,
      ort: source.inland.ort,
      postleitzahl: source.inland.postleitzahl
    };
  }
}
